import React, { ReactNode } from 'react';
import { Box, Stack, Text } from '@atlaskit/primitives';
import { validateFreeSubscriptions } from '@css-xp/entitlements-v2';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { NoData, FormatCurrency } from '@css-xp/ppc-common';
import { isEnterpriseInstanceOffering, isMultiInstanceAppInstance } from '@css-xp/ppc-utils';
import { cardStyles, HeadingText } from './entitlement-cards.styles';

export type NextPriceEstimateProps = {
  entitlement: EntitlementDetails;
  isMultiInstanceAppsEnabled?: boolean;
};

export const NextPriceEstimate = ({ entitlement, isMultiInstanceAppsEnabled }: NextPriceEstimateProps) => {
  const { nextBillEstimate } = entitlement;

  const isFreePlan = validateFreeSubscriptions(entitlement);
  const isEnterpriseInstance = isEnterpriseInstanceOffering(entitlement.edition);
  const isMultiInstanceAppInstanceProduct =
    isMultiInstanceAppsEnabled && isMultiInstanceAppInstance(entitlement?.offeringId);

  let nextNextPriceEstimateText: string | ReactNode = <NoData />;
  const nextBillEstimateTotal = nextBillEstimate?.total ?? 0;

  if (isFreePlan) {
    nextNextPriceEstimateText = 'N/A';
  } else if (isEnterpriseInstance) {
    nextNextPriceEstimateText = 'Included in Enterprise plan';
  } else if (nextBillEstimateTotal && !isMultiInstanceAppInstanceProduct) {
    nextNextPriceEstimateText = (
      <span>
        <FormatCurrency
          value={nextBillEstimateTotal}
          currency={nextBillEstimate?.currency}
          showCurrencyCode
          showCommas
        />
      </span>
    );
  }

  return (
    <Box padding="space.200" xcss={cardStyles}>
      <Stack space="space.100" alignBlock="center">
        <Text size="small" color="color.text.subtlest">
          Next price estimate
        </Text>
        <HeadingText>{nextNextPriceEstimateText}</HeadingText>
        {!isMultiInstanceAppInstanceProduct && nextBillEstimateTotal > 0 && (
          <Text color="color.text.subtle">Excludes tax</Text>
        )}
      </Stack>
    </Box>
  );
};
